<template>
    <requests-edit-table
        v-bind:requests="requests"
        v-bind:options="options"
        group-by="order"
        v-on:change="handleChange"
    ></requests-edit-table>
</template>



<script>
import RequestsEditTable from './RequestsEditTable';


export default {
    props: {
        requests: { type: Array, required: true },
        options:  {}
    },


    computed: {
        requestsSelected: {
            get: function () {
                return this.$store.state.requestsSelected;
            },
            set: function (value) {
                this.$store.state.requestsSelected = value;
            }
        }
    },


    methods: {
        selectAll() {
            this.requestsSelected = JSON.parse(JSON.stringify(this.requests));
        },

        handleChange() {
            this.$store.dispatch('fillEmailBody');
        }
    },


    mounted: function () {
        this.requestsSelected = this.requestsSelected.filter(request => !['canceled', 'called_off'].includes(request.requestStatus.status));
        this.$store.dispatch('fillEmailBody');
    },


    watch: {
        requests: function () {
            this.selectAll();
        }
    },


    created() {
        this.selectAll();
    },


    components: {
        RequestsEditTable
    }
}
</script>
